import {
  InputGroup, InputRightElement, Input, Icon,
  InputGroupProps,
  useColorModeValue,
} from "@chakra-ui/react";
import { debounce } from "lodash";
import { useEffect, useState, useCallback } from "react";
import { FiSearch } from "react-icons/fi";

interface SearchBarProps extends InputGroupProps {
  placeholder?: string;
  input?: string;
  onInput: (data: any) => void;
  variant?: string;
  searchIconColor?: string;
  inputProps?: object;
}

export default function SearchBar({
  placeholder = "Search",
  input = "",
  onInput,
  variant = "outline",
  searchIconColor = "searchBarGrey.DEFAULT",
  inputProps = {},
  ...rest
}: SearchBarProps) {
  const [searchInput, setSearchInput] = useState(input);
  const searchBarColor = useColorModeValue("searchBarGrey.DEFAULT", "searchBarGrey.DEFAULT");

  // Sync internal state when input prop changes (e.g., when filters are reset)
  useEffect(() => {
    setSearchInput(input);
  }, [input]);

  const notifyInput = debounce(onInput, 400);
  const onInputChange = useCallback((value: string) => {
    setSearchInput(value);
    notifyInput(value);
  }, [onInput]);

  return (
    <InputGroup
      borderRadius="4px"
      color={searchBarColor}
      maxW="md"
      display="inline-flex"
      {...rest}
    >
      <InputRightElement height="100%">
        <Icon as={FiSearch} color={searchIconColor} fontSize="lg" />
      </InputRightElement>
      <Input
        value={searchInput}
        color="fg.muted"
        borderColor={searchBarColor}
        onChange={(e) => onInputChange(e.target.value)}
        placeholder={placeholder}
        variant={variant}
        {...inputProps}
      />
    </InputGroup>
  );
}
